import { render, staticRenderFns } from "./SocialsListBig.vue?vue&type=template&id=68da2152"
import script from "./SocialsListBig.vue?vue&type=script&lang=js"
export * from "./SocialsListBig.vue?vue&type=script&lang=js"
import style0 from "./SocialsListBig.vue?vue&type=style&index=0&id=68da2152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports